import { ApplicationConfig, enableProdMode, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { provideEnvironmentNgxMask } from 'ngx-mask';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    importProvidersFrom(
      NgxLoadingModule.forRoot({
        animationType: ngxLoadingAnimationTypes.wanderingCubes,
        backdropBackgroundColour: "#e6eeff",
        backdropBorderRadius: "4px",
        primaryColour: "#2a6af6",
        secondaryColour: "#2a6af6",
        tertiaryColour: "#2a6af6",
        fullScreenBackdrop: true
      })
    ),
    provideEnvironmentNgxMask()
  ]
};

export const appEnv = {
  production: environment.production,
  dev: environment.development,
  stage: environment.stage,
  api: environment.api
};

if (appEnv.production) {
  enableProdMode();
} else {
  isDevMode();
}
